import {
    SET_SELECTED_COST_CENTER,
    SET_SELECTED_ORDER_TYPE,
    SET_VEHICLE_TYPE,
    SET_MAKE_LIST,
    SET_VEHICLE_SPEC_LIST,
    SET_ORDER_DATA,
    SET_ORDER_CART_DATA,
    SET_MANAGED_EQUIPEMENT_TYPES,
    SET_CATALOG_ITEMS,
    SET_BULK_ORDER_ATTACHMENTS,
    REMOVE_BULK_ORDER_ATTACHMENT,
    SHOW_MY_CART_ALERT,
    SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_BULK_ORDER_FLEET_ATTACHMENTS,
    SET_IS_APPROVAL_OVERRIDE
} from "./BulkOrderType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_SELECTED_COST_CENTER:
            return {
                ...state,
                selectedCostCenter: action.costcenter,
            };
        case SET_SELECTED_ORDER_TYPE:
            return {
                ...state,
                selectedOrderType: action.orderType,
            };
        case SET_IS_APPROVAL_OVERRIDE:
            return {
                ...state,
                isApprovalOverride: action.isApprovalOverride,
            };
        case SET_VEHICLE_TYPE:
            return {
                ...state,
                vehicleType: action.vehicleType,
            };
        case SET_MAKE_LIST:
            return {
                ...state,
                makeList: action.makeList,
            };
        case SET_VEHICLE_SPEC_LIST:
            return {
                ...state,
                vehicleSpecList: action.vehicleSpecList,
            };
        case SET_ORDER_DATA:
            return {
                ...state,
                orderDetails: action.data,
            };
        case SET_ORDER_CART_DATA:
            return {
                ...state,
                orderCartDetails: action.cartData,
            };
        case SET_MANAGED_EQUIPEMENT_TYPES:
            return {
                ...state,
                managedEquipementsList: action.managedEquipementsList,
            };
        case SET_CATALOG_ITEMS:
            return {
                ...state,
                catalogItemDetails: action.catalogItems,
            };
        case SET_BULK_ORDER_ATTACHMENTS:
            return {
                ...state,
                attachmentList: {list: action.attachmentList, requestIndex: action.requestIndex}
            };
        case REMOVE_BULK_ORDER_ATTACHMENT:
            return {
                ...state,
                attachmentList: {list: action.attachmentList, requestIndex: action.requestIndex},
            };
        case SHOW_MY_CART_ALERT:
            return {
                ...state,
                showAlert: {isSucessfull: action.isSucessfull, label: action.label},
            };   
        case SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN:
            return{
                ...state,
                managedEquipmentDropDown: action.managedEquipmentDropDown
            }

        case SET_BULK_ORDER_FLEET_ATTACHMENTS:
            return{
                ...state,
                bulkOrderFleetAttachments: action.bulkOrderFleetAttachments
            }
        default:
            return state;
    }
};

export {
    reducers
};